import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router-dom'

// Context Providers
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { AnalyticsProvider } from './contexts/AnalyticsContext'

// Layout Components
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'

// Pages
// "/" and the enquiry form are served by the static animated site in
// scrollcraft/builds/novahass-fall, assembled into dist by scripts/build-site.mjs.
// The OAuth screens were removed because they inlined VITE_GOOGLE_CLIENT_SECRET
// into the public bundle; token refresh already happens inside functions/api.
import BookNowPage from './pages/BookNowPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import NotFoundPage from './pages/NotFoundPage'

// Page transition variants
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: -20,
  },
}

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.4,
}

const Page: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
  >
    {children}
  </motion.div>
)

function App() {
  const location = useLocation()

  return (
    <ThemeProvider>
      <AuthProvider>
        <AnalyticsProvider>
        <div className="relative min-h-screen flex flex-col">
              <Header />

              <main className="flex-1">
                <AnimatePresence mode="wait">
                  <Routes location={location} key={location.pathname}>
                    <Route path="/book" element={<Page><BookNowPage /></Page>} />
                    <Route path="/privacy-policy" element={<Page><PrivacyPolicyPage /></Page>} />
                    <Route path="/cookie-policy" element={<Page><CookiePolicyPage /></Page>} />
                    <Route path="/terms-of-service" element={<Page><TermsOfServicePage /></Page>} />
                    <Route path="*" element={<Page><NotFoundPage /></Page>} />
                  </Routes>
                </AnimatePresence>
              </main>

              <Footer />
        </div>
        </AnalyticsProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
